// TODO: Move this data into dbo.Tools next time we refactor this code
const internationalSupportedCtaToolIds = new Set([15, 16, 25, 27, 28, 37, 42]);

const domesticSupportedCtaToolIds = new Set([
    2,
    15,
    16,
    22,
    23,
    24,
    25,
    26,
    27,
    28,
    29,
    30,
    31,
    32,
    37,
    42,
    43,
    48,
    49,
    50,
    51,
]);

export const getCtaToolOptions = (tools, isInternational) => {
    if (!tools) return [];

    const supportedIds = isInternational ? internationalSupportedCtaToolIds : domesticSupportedCtaToolIds;

    return tools
        .filter((tool) => !tool.promoPanel && supportedIds.has(tool.toolId))
        .map((tool) => ({
            value: tool.toolId,
            label: tool.name,
        }));
};